module.exports = __webpack_public_path__ + "img/basket-icon-orange.a824dcdc.svg";